module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/collapse-arrows-672e79e1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/collapse-arrows.svg
// module id = ./app/web/src/assets/collapse-arrows.svg
// module chunks = 0